import FaqDetails from "@/components/faq/FaqDetails";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: "Hubzu | FAQ",
};

const FaqDetailsPage = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <FaqDetails />
    </>
  );
};

export default FaqDetailsPage;
